<template>
    <button class="solid-text-button"  @click="clickHandler">
        {{ label }}
    </button>
</template>

<script>
export default {
    name: "solid-text-button",
    props: [
        "id",
        "label",
        "icon",
        "clickHandler"
    ]
}
</script>

<style>

.solid-text-button {
    height: 30px;
    border-radius: 15px;
    padding-left: 25px;
    padding-right: 25px;
    background-color: #314584;
    color: #ffffff;
}

.solid-text-button:hover {
    opacity: .66;
}

.solid-text-button:active {
    opacity: .33;
}

</style>